import React, { useState } from 'react';

import { LoadingOutlined, SearchOutlined } from '@ant-design/icons';
import { Input, Button, message, Select, Checkbox, Spin } from 'antd';
import { Formik, ErrorMessage } from 'formik';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { T } from 'react-translator-component';
import styled from 'styled-components';

import {
  createOcppTag,
  updateOcppTag,
  getTenantParentOcppTagByCPF,
} from '../../hooks/ocpptags';
import { cpfMask } from '../../utils/masks';

const { Option } = Select;
const { Search } = Input;

const OcppTagFormWrapper = styled.div`
  form {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;

    label:first-child {
      margin-right: 10px;
    }

    .send_button {
      margin-top: 20px;
    }
  }

  .select_filter {
    width: 340px;
  }
`;

const FormSet = styled.div``;

const FormLabel = styled.label`
  font-size: 14px;
  font-weight: bold;
`;

const FormInputWrapper = styled.div`
  width: 350px;
  margin-top: 20px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;

  select {
    padding: 4px 20px 4px 8px;
    border: 1px solid #d9d9d9;
    border-radius: 2px;
    touch-action: manipulation;
    appearance: none;
    background-image: url("data:image/svg+xml,%3C%3Fxml version='1.0' standalone='no'%3F%3E%3C!DOCTYPE svg PUBLIC '-//W3C//DTD SVG 1.1//EN' 'http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd'%3E%3Csvg t='1597601650772' class='icon' viewBox='0 0 1024 1024' version='1.1' xmlns='http://www.w3.org/2000/svg' p-id='1210' xmlns:xlink='http://www.w3.org/1999/xlink' width='16' height='16'%3E%3Cdefs%3E%3Cstyle type='text/css'%3E%3C/style%3E%3C/defs%3E%3Cpath d='M726.652801 429.305603 297.347199 429.305603 512.193405 638.156258Z' p-id='1211'%3E%3C/path%3E%3C/svg%3E");
    background-repeat: no-repeat;
    background-position: right;

    &:focus {
      border-color: #40a9ff;
      border-right-width: 1px !important;
      outline: 0;
      -webkit-box-shadow: 0 0 0 2px rgba(24, 144, 255, 0.2);
      box-shadow: 0 0 0 2px rgba(24, 144, 255, 0.2);
    }

    &:hover {
      border-color: #40a9ff;
      border-right-width: 1px !important;
    }
  }

  /* @media (min-width: 1024px) {
    input:not([type='checkbox']) {
      min-width: 300px;
    }
  } */

  input:hover,
  input:focus,
  input:active,
  input:disabled:hover,
  .ant-input-affix-wrapper:hover,
  .ant-input-affix-wrapper:focus,
  .ant-input-affix-wrapper:active,
  .ant-input-affix-wrapper:visited,
  .ant-input-affix-wrapper-focused,
  select:hover,
  select:focus,
  select:active,
  textarea:hover,
  textarea:focus,
  textarea:active {
    border-right-width: 0 !important;
    border-color: #40a9ff;
    outline: none;
    box-shadow: none;
  }

  input:disabled:hover {
    border-color: rgba(0, 0, 0, 0.3);
  }

  .ant-input-affix-wrapper {
    border-right-width: 0 !important;
  }

  input,
  .ant-input-affix-wrapper,
  select,
  textarea {
    font-size: 14px;
    font-weight: normal;
    border-radius: 0 0 1px 0;
    border-width: 0 0 1px 0;
    border-color: #000;

    /* &:hover,
    &:focus,
    &:disabled:hover {
      border-right-width: 0 !important;
      box-shadow: none;
    } */
  }

  input[type='number']::-webkit-outer-spin-button,
  input[type='number']::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  .search_cpf_button {
    height: 30px;
    margin: 0 0 5px 10px;
  }

  .search_cpf_input {
    width: 340px;
    margin-bottom: 10px;
  }
`;

const FormInputGroupWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: center;
  width: 100%;

  > div:first-child {
    margin-right: 40px;
  }
`;

const MessageBox = styled.div`
  color: red;
  font-size: 12px;
`;

const InputField = styled.input``;

const antLoadingIcon = <LoadingOutlined style={{ fontSize: 24 }} spin />;

const OcppTagForm = ({
  initialValues,
  loading,
  type,
  ocppTagPk = null,
  ocppTags,
  usersList,
  tenants,
}) => {
  const history = useHistory();
  const routes = useSelector((state) => state.user.routes);
  const [inputCpf, setInputCpf] = useState(false);
  const [cpf, setCpf] = useState('');
  const [loadingCpf, setLoadingCpf] = useState(false);

  return (
    <Formik
      initialValues={initialValues}
      validate={(values) => {
        const errors = {};
        return errors;
      }}
      onSubmit={(values, { setSubmitting }) => {
        setSubmitting(true);
        setTimeout(async () => {
          let data = null;
          if (
            values.parent_id_tag != null &&
            values.parent_id_tag.length != 0 &&
            values.parent_id_tag.trim()
          ) {
            values.parent_id_tag = values.parent_id_tag.split(' - ')[0];
          }
          if (type === 'create') {
            data = await createOcppTag(values);
          } else if (type === 'update') {
            data = await updateOcppTag(values, ocppTagPk);
          }

          if (data !== null) {
            if (data.type === 'success') {
              if (type === 'create') {
                message.success('OCPP Tag successfully created!');
              } else {
                message.success('OCPP Tag successfully updated!');
              }
              setTimeout(() => {
                history.push('/ocpptags');
              }, 1000);
            } else {
              if (data?.data?.error?.includes('already exists')) {
                message.error(`Tag RFID ${values.id_tag} já cadastrada!`);
              } else {
                message.error(
                  'Unable to perform the operation. Make sure the fields are filled in correctly.',
                );
              }
            }
          } else {
            message.error(
              'Unable to perform the operation. Make sure the fields are filled in correctly.',
            );
          }
          setSubmitting(false);
        }, 400);
      }}
    >
      {({
        values,
        errors,
        touched,
        handleChange,
        handleBlur,
        handleSubmit,
        isSubmitting,
        setFieldValue,
      }) => {
        const handleInputCpf = () => {
          if (inputCpf) {
            setInputCpf(false);
          } else {
            setInputCpf(true);
          }
        };

        const handleCpfChange = (e) => {
          setCpf(cpfMask(e.target.value));
        };

        const handleSearchCpf = async () => {
          setLoadingCpf(true);
          const result = await getTenantParentOcppTagByCPF(
            cpf.replace(/\D/g, ''),
          );

          if (result?.data?.error || result?.ocppTag == null) {
            message.error(T('User not found!'));
          } else {
            values.parent_id_tag = `${result?.ocppTag?.idTag} - (${result?.ocppTag?.userName})`;
          }
          setLoadingCpf(false);
        };
        return (
          <OcppTagFormWrapper>
            <form onSubmit={handleSubmit}>
              <FormInputGroupWrapper>
                <FormInputWrapper>
                  <FormLabel>{T('Tag ID')}:</FormLabel>
                  <Input
                    name='id_tag'
                    label='id_tag'
                    onChange={handleChange}
                    onBlur={handleBlur}
                    value={values.id_tag}
                    required
                    maxLength={20}
                    allowClear
                    disabled={values.type == 'USER'}
                  />
                  <ErrorMessage name='id_tag' component={MessageBox} />
                </FormInputWrapper>

                <FormInputWrapper>
                  <FormLabel>{T('Type')}:</FormLabel>
                  <InputField
                    type='string'
                    name='type'
                    label='type'
                    as='select'
                    onChange={handleChange}
                    onBlur={handleBlur}
                    value={values.type}
                    required
                    maxLength={20}
                    allowClear
                    disabled
                  >
                    <option key='CARD' value='CARD'>
                      {T('CARD')}
                    </option>
                    <option key='USER' value='USER'>
                      {T('USER')}
                    </option>
                  </InputField>
                  <ErrorMessage name='type' component={MessageBox} />
                </FormInputWrapper>
              </FormInputGroupWrapper>

              <FormInputGroupWrapper>
                <FormInputWrapper>
                  <FormLabel>{T('Account')}:</FormLabel>
                  {loading ? (
                    <Spin indicator={antLoadingIcon} />
                  ) : (
                    <InputField
                      type='number'
                      as='select'
                      name='tenant_pk'
                      label='tenant_pk'
                      onChange={handleChange}
                      onBlur={handleBlur}
                      value={values.tenant_pk}
                      required
                      maxLength={20}
                      allowClear
                    >
                      {tenants?.list?.length &&
                        tenants?.list?.map(({ tenant_pk, name }) => (
                          <option value={tenant_pk}>
                            {tenant_pk} - {name}
                          </option>
                        ))}
                    </InputField>
                  )}
                  <ErrorMessage name='tenant_pk' component={MessageBox} />
                </FormInputWrapper>

                {values.type == 'CARD' ? (
                  <FormInputWrapper>
                    <FormSet>
                      <FormLabel>{T('Card User')}:</FormLabel>
                      {routes &&
                      routes.find(
                        ({ path }) => path === '/users_data/tenant_parent/cpf',
                      ) &&
                      values.type == 'CARD' ? (
                        <>
                          <Button
                            className='search_cpf_button'
                            type='primary'
                            onClick={handleInputCpf}
                            icon={<SearchOutlined />}
                          >
                            {T('CPF')}
                          </Button>

                          {inputCpf && (
                            <Search
                              value={cpf}
                              maxLength='14'
                              onChange={handleCpfChange}
                              className='search_cpf_input'
                              placeholder={T('Informe o CPF Completo')}
                              enterButton='Pesquisar'
                              size='middle'
                              onSearch={handleSearchCpf}
                              loading={loadingCpf}
                            />
                          )}
                        </>
                      ) : null}
                    </FormSet>
                    {loading ? (
                      <Spin indicator={antLoadingIcon} />
                    ) : (
                      <Select
                        allowClear
                        showSearch
                        name='parent_id_tag'
                        className='select_filter'
                        value={values.parent_id_tag}
                        onChange={(value) => {
                          setFieldValue('parent_id_tag', value);
                        }}
                        onBlur={handleBlur}
                        placeholder={T('Search to Select')}
                        optionFilterProp='children'
                        filterOption={(input, option) => {
                          if (typeof option?.value === 'string') {
                            return option?.value
                              ?.toLowerCase()
                              .includes(input?.toLowerCase());
                          } else {
                            return false;
                          }
                        }}
                        filterSort={(optionA, optionB) => {
                          if (!optionA?.value || !optionB?.value) {
                            return 0;
                          }
                          return optionA?.value > optionB?.value ? 1 : -1;
                        }}
                        disabled={values.type == 'USER'}
                      >
                        {ocppTags?.ocppTagList?.length &&
                          ocppTags.ocppTagList.map((ocppTag, index) => (
                            <Option key={index} value={ocppTag.idTag}>
                              {ocppTag.idTag} - ({ocppTag.userName})
                            </Option>
                          ))}
                      </Select>
                    )}
                    <ErrorMessage name='parent_id_tag' component={MessageBox} />
                  </FormInputWrapper>
                ) : (
                  <FormInputWrapper />
                )}
              </FormInputGroupWrapper>

              <FormInputGroupWrapper>
                {type === 'update' && (
                  <FormInputWrapper>
                    <FormLabel>{T('Inactivate Tag')}:</FormLabel>
                    <Checkbox
                      name='inactive'
                      label='inactive'
                      as='select'
                      onChange={handleChange}
                      onBlur={handleBlur}
                      checked={values.inactive}
                    />
                    <ErrorMessage name='inactive' component={MessageBox} />
                  </FormInputWrapper>
                )}

                <FormInputWrapper style={{ width: '100%' }}>
                  <FormLabel>{T('Recarga gratuita')}:</FormLabel>
                  <Checkbox
                    name='isFreeRecharge'
                    label='Recarga gratuita'
                    as='select'
                    onChange={handleChange}
                    onBlur={handleBlur}
                    checked={values.isFreeRecharge}
                  />
                  <ErrorMessage name='isFreeRecharge' component={MessageBox} />
                </FormInputWrapper>
              </FormInputGroupWrapper>

              <FormInputWrapper style={{ width: '100%' }}>
                <FormLabel>{T('Additional Note')}:</FormLabel>
                <Input
                  name='note'
                  label='note'
                  onChange={handleChange}
                  onBlur={handleBlur}
                  value={values.note}
                  required
                  maxLength={200}
                  allowClear
                />
                <ErrorMessage name='note' component={MessageBox} />
              </FormInputWrapper>

              <Button
                className='send_button'
                type='primary'
                disabled={isSubmitting}
                onClick={handleSubmit}
              >
                {T('Submit')}
              </Button>
            </form>
          </OcppTagFormWrapper>
        );
      }}
    </Formik>
  );
};

export default OcppTagForm;
